import { useState } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function VaccinationForm({ onAdd }) {
  const [date, setDate] = useState(() => toDatetimeLocal());
  const [vaccineName, setVaccineName] = useState("");
  const [dose, setDose] = useState("");
  const [nextDueDate, setNextDueDate] = useState("");
  const [notes, setNotes] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!vaccineName) return;

    onAdd({
      date: new Date(date).toISOString(),
      vaccineName,
      dose: dose || "",
      nextDueDate: nextDueDate || "",
      notes: notes || "",
    });

    setDate(toDatetimeLocal());
    setVaccineName("");
    setDose("");
    setNextDueDate("");
    setNotes("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2 mb-2">
        <div className="col-md-4">
          <label className="form-label">Date Given</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
      </div>
      <div className="row g-2">
        <div className="col-md-4">
          <label className="form-label">Vaccine Name</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. DTaP, MMR, Flu"
            value={vaccineName}
            onChange={(e) => setVaccineName(e.target.value)}
            required
          />
        </div>
        <div className="col-md-2">
          <label className="form-label">Dose #</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. 1st"
            value={dose}
            onChange={(e) => setDose(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <label className="form-label">Next Due Date</label>
          <input
            type="date"
            className="form-control"
            value={nextDueDate}
            onChange={(e) => setNextDueDate(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <label className="form-label">Notes</label>
          <input
            type="text"
            className="form-control"
            placeholder="Reactions, clinic, etc."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
        <div className="col-md-2 d-flex align-items-end">
          <button type="submit" className="btn btn-success w-100">
            Add
          </button>
        </div>
      </div>
    </form>
  );
}
